const Algorithms = [{
        value: 'RS256',
        display_name: 'RSA Signature with SHA-256'
    },
    {
        value: 'ES256',
        display_name: 'ECDSA using P-256 and SHA-256'
    },
    {
        value: 'HS256',
        display_name: 'HMAC using SHA-256'
    }
];

export default Algorithms;